module.exports = function anonymous(it
) {
var out='<ul class="js-results tt-results"> ';var arr1=it.entries;if(arr1){var entry,i1=-1,l1=arr1.length-1;while(i1<l1){entry=arr1[i1+=1];out+=' <li class="js-entity-item "> '+( it.entryTemplate(entry) )+' </li> ';} } out+='</ul>';return out;
}